/* Independent storefront picker. Activate only after the Cart Transform app is installed. */
(() => {
  for (const root of document.querySelectorAll('.glaam-variant-picker')) {
    if (root.dataset.ready) continue;
    root.dataset.ready = 'true';
    const catalog = JSON.parse(root.querySelector('.glaam-builder__catalog').textContent);
    const config = JSON.parse(root.querySelector('.glaam-builder__config').textContent);
    const labels = JSON.parse(root.querySelector('.glaam-builder__labels').textContent);
    const customization = config.dashboard || {};
    if(customization.enabled===false){root.closest('#glaam-variant-demo').hidden=true;continue;}
    const popupTitle = customization.popupTitle || 'Choisissez vos couleurs';
    if(customization.slotLabel) labels.slot=customization.slotLabel;
    if(customization.addLabel) labels.add=customization.addLabel;
    if(customization.chooseProduct) labels.select=customization.chooseProduct;
    const applyCustomization = () => window.GlaamPackCustomization?.apply(root,customization);
    const slotLabel = index => labels.slot.replaceAll('{n}', String(index + 1)).replaceAll('%n', String(index + 1));
    let count = Number(root.dataset.colors);
    const originalPack = root.dataset.pack;
    // On the draft preview, the installed Cart Transform handles the base pack.
    const standalonePreview = root.dataset.bridge === 'true' &&
      new URLSearchParams(window.location.search).get('glaam_standalone_preview') === '1';
    const previewOnly = root.dataset.preview === 'true';
    const bridgeMode = root.dataset.bridge === 'true' && !standalonePreview;
    // Enable only after the new Glaam Packs Cart Transform version is released
    // and its extra-color prices have been checked in the draft cart.
    const extrasCheckoutEnabled = root.dataset.extrasEnabled === 'true' && customization.extrasEnabled!==false;
    const extraDiscount=customization.extrasDiscountEnabled===false?0:(customization.extrasDiscountPercent??20);
    const extraFactor=1-extraDiscount/100;
    const extraBadge=extraDiscount>0?'−'+extraDiscount+' %':'+';

    let selectedVariant = null;
    let addingToCart = false;
    const picked = Array(count).fill(null);
    // The published theme's wishlist stores product handles in wishlist:v1.
    // Read it afresh when the modal opens so favorites added elsewhere appear.
    const readFavorites = () => {
      try {
        const items = window.Wishlist?.read?.() || JSON.parse(localStorage.getItem('wishlist:v1') || '[]');
        return new Set(Array.isArray(items) ? items.filter(item => typeof item === 'string') : []);
      } catch (_) { return new Set(); }
    };
    let favoritesOnly = false;
    const modal = root.querySelector('.glaam-builder__modal');
    modal.classList.add('glaam-variant-modal');
    const gallery = root.querySelector('.glaam-builder__gallery');
    const grid = root.querySelector('.glaam-builder__grid');
    const filters = root.querySelector('.glaam-builder__filters');
    const search = root.querySelector('.glaam-builder__search');
    const message = root.querySelector('.glaam-builder__message');
    const add = root.querySelector('.glaam-builder__add');
    const modalAdd = modal.querySelector('.glaam-builder__modal-add');
    const contentsAdd = root.querySelector('.glaam-builder__contents-add');
    const sticky = root.querySelector('.glaam-builder__sticky');
    const stickyAdd = sticky.querySelector('.glaam-builder__sticky-add');
    const summary = modal.querySelector('.glaam-builder__summary');
    const selectedCount = root.querySelector('.glaam-builder__selected-count');
    const sortSelect = modal.querySelector('[data-glaam-sort]');
    modal.querySelector('.glaam-builder__sort-control').hidden=customization.showSort===false;
    modal.querySelector('.glaam-builder__filter-toggle').hidden=customization.showFilter===false;
    modal.querySelector('.glaam-builder__search-toggle').hidden=customization.showSearch===false;
    if(customization.defaultSort) sortSelect.value=customization.defaultSort;
    let bestSellerRanks = null;
    let bestSellerLoading = null;
    async function loadBestSellerRanks() {
      const handles = [];
      let page = 1;
      while (page) {
        const url = new URL((window.Shopify?.routes?.root || '/') + 'collections/'+(customization.catalogHandle || 'glaam-nails'),location.origin);
        url.searchParams.set('view','glaam-sort');
        url.searchParams.set('sort_by','best-selling');
        url.searchParams.set('page',String(page));
        url.searchParams.set('preview_theme_id',String(config.themeId));
        const response = await fetch(url);
        if (!response.ok) throw new Error('Tri indisponible');
        const data = await response.json();
        handles.push(...data.handles);
        page = data.nextPage;
      }
      bestSellerRanks = new Map(handles.map((handle,index)=>[handle,index]));
    }
    sortSelect.addEventListener('change', async () => {
      if (['recommended','best-selling'].includes(sortSelect.value) && !bestSellerRanks) {
        sortSelect.disabled = true;
        try {
          bestSellerLoading ||= loadBestSellerRanks();
          await bestSellerLoading;
        } catch (_) {
          bestSellerLoading = null;
          sortSelect.value = 'recommended';
          modal.querySelector('.glaam-builder__modal-message').textContent = 'Le tri des meilleures ventes est momentanément indisponible.';
        } finally { sortSelect.disabled = false; }
      }
      draw();
      grid.scrollTop = 0;
    });

    const pageSlots = root.querySelector('.glaam-builder__slots');
    const extraSlots = document.createElement('div');
    const baseRow = document.createElement('div');
    baseRow.className = 'glaam-builder__summary-row';
    summary.replaceChildren(baseRow);
    function makeColorCarousel(track, kind) {
      const frame = document.createElement('div');
      frame.className = 'glaam-colors-carousel glaam-colors-carousel--' + kind;
      track.before(frame);
      frame.append(track);
      track.classList.add('glaam-colors-carousel__track');
      track.tabIndex = 0;
      track.setAttribute('aria-label', kind === 'page' ? 'Couleurs du pack' : 'Votre sélection de couleurs');
      const buttons = [-1,1].map(direction => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'glaam-colors-carousel__arrow glaam-colors-carousel__arrow--' + (direction < 0 ? 'prev' : 'next');
        button.textContent = direction < 0 ? '‹' : '›';
        button.setAttribute('aria-label', direction < 0 ? 'Couleurs précédentes' : 'Couleurs suivantes');
        button.addEventListener('click', () => {
          const first = track.firstElementChild;
          const step = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
          track.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        });
        frame.append(button);
        return button;
      });
      const refresh = () => {
        const max = track.scrollWidth - track.clientWidth;
        buttons[0].hidden = max <= 2 || track.scrollLeft <= 2;
        buttons[1].hidden = max <= 2 || track.scrollLeft >= max - 2;
      };
      track.addEventListener('scroll', refresh, {passive:true});
      new ResizeObserver(refresh).observe(track);
      return refresh;
    }
    const refreshPageCarousel = makeColorCarousel(pageSlots, 'page');
    const refreshSummaryCarousel = makeColorCarousel(baseRow, 'summary');
    // A transformed product-info ancestor makes position:fixed relative to that
    // ancestor. Mount the dialog on body so it follows the viewport instead.
    document.body.append(modal);
    document.body.append(gallery);
    const priceNode = document.createElement('span');
    const plainPrice = value => { priceNode.innerHTML = value || ''; return priceNode.textContent.trim(); };
    let displayPrice = plainPrice(config.price);
    let modContainer = null;
    let slot = 0;
    let color = '';
    let effect = '';
    let productType = '';
    let previousFocus;
    let previousOverflow = '';
    let galleryProduct = null;
    let galleryIndex = 0;
    let galleryFocus = null;
    const rows = null;
    const originalOldPrices = {};
    rows?.querySelectorAll('a.bql-row').forEach(row => {
      const key = Object.keys(config.packs || {}).find(kind => row.href.includes(`/products/${config.packs[kind].handle}`));
      const old = row.querySelector('.bql-row-old')?.textContent.trim();
      if (key && old) originalOldPrices[key] = old;
    });
    const formulaButtons = [];
    const colorsHeading = root.querySelector('.glaam-builder__step-title');
    selectedCount.hidden = true;
    const countAtHeading = colorsHeading?.querySelector('.glaam-builder__heading-count');
    const originalContents = null;
    const includedImages = [...(originalContents?.querySelectorAll('.produits-inclus__item') || [])].map(item => ({
      name: item.querySelector('.produits-inclus__name')?.textContent.trim() || '',
      image: item.querySelector('img')?.src || ''
    }));
    const includedImage = term => includedImages.find(item => item.name.toLocaleLowerCase('fr').includes(term))?.image;
    const originalFormula = root.dataset.pack.startsWith('no') ? 'without' : 'with';
    let originalRows = rows?.innerHTML;
    let currentFormula = originalFormula;
    let currencyDisplay = null;
    function amount(value) {
      const raw = value.match(/\d[\d\s.,]*/)?.[0]?.trim();
      if (!raw) return NaN;
      const decimal = raw.lastIndexOf(',') > raw.lastIndexOf('.') ? ',' : '.';
      return Number(raw.replace(/[\s.,]/g, char => char === decimal ? '.' : ''));
    }
    function calibratePrice() {
      if (currencyDisplay) return;
      const shown = rows?.querySelector('.bql-row--selected .bql-row-new')?.textContent.trim();
      const base = plainPrice(config.price);
      const shownAmount = amount(shown || '');
      const baseAmount = amount(base);
      if (!shownAmount || !baseAmount) return;
      const unit = shown.replace(/\d[\d\s.,]*/, '').trim();
      currencyDisplay = { factor: shownAmount / baseAmount, unit, decimal: shown.includes(',') && !shown.includes('.') ? ',' : '.' };
    }
    function shownPrice(pack, kind) {
      const live = root.querySelector(`[data-pack-price="${kind}"]`)?.textContent.trim();
      if (live) return live;
      const original = plainPrice(pack.price);
      if (!currencyDisplay || Math.abs(currencyDisplay.factor - 1) < .001) return original;
      const value = amount(original) * currencyDisplay.factor;
      if (!Number.isFinite(value)) return original;
      return `${value.toFixed(2).replace('.', currencyDisplay.decimal)} ${currencyDisplay.unit}`.trim();
    }
    const chosenByFormula = { with: originalFormula === 'with' ? root.dataset.pack : 'decouverte',
      without: originalFormula === 'without' ? root.dataset.pack : 'no6' };

    function updateAdd() {
      const left = picked.slice(0, count).filter(p => !p).length;
      const otherPackInBridge = bridgeMode && root.dataset.pack !== originalPack;
      const extraCount = Math.max(0, picked.length - count);
      const chosen = count - left;
      const countText = `${chosen} / ${count} sélectionnées`;
      const extras = picked.slice(count).filter(Boolean);
      pageSlots.querySelectorAll('[data-inline-extra]').forEach(node => node.remove());
      extraSlots.replaceChildren();
      picked.slice(count).forEach((product, extraIndex) => {
        const index = count + extraIndex;
        const wrap = document.createElement('div');
        wrap.className = 'glaam-builder__slot-wrap';
        const tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'glaam-builder__slot';
        tile.dataset.extraSlot = String(index);
        if (product) {
          const img = document.createElement('img');
          img.src = product.image;
          img.alt = '';
          const name = document.createElement('span');
          name.textContent = product.name;
          tile.append(img, name);
          tile.setAttribute('aria-label', `Modifier la couleur supplémentaire ${extraIndex + 1} : ${product.name}`);
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'glaam-builder__remove';
          remove.dataset.removeExtra = String(index);
          remove.textContent = '×';
          remove.setAttribute('aria-label', `Supprimer ${product.name}`);
          wrap.append(remove);
        } else {
          tile.innerHTML = '<span class="glaam-builder__plus">+</span><small>'+extraBadge+'</small>';
        }
        wrap.append(tile);
        wrap.dataset.inlineExtra = '';
        extraSlots.append(wrap);
      });
      if (extrasCheckoutEnabled && !bridgeMode && !left && picked.length - count < 9 && !picked.slice(count).some(item => !item)) {
        const tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'glaam-builder__slot';
        tile.dataset.pageAddExtra = '';
        tile.innerHTML = '<span class="glaam-builder__plus">+</span><small>'+extraBadge+'</small>';
        const wrap = document.createElement('div');
        wrap.className = 'glaam-builder__slot-wrap';
        wrap.dataset.inlineExtra = '';
        wrap.append(tile);
        extraSlots.append(wrap);
      }
      pageSlots.append(...extraSlots.children);
      const extraValue = extras.reduce((sum, product) => sum + Math.round(Number(product.priceCents || 0) * extraFactor) / 100, 0);
      const formatMoney = value => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: config.currency || 'EUR' }).format(value);
      const totalPrice = extraValue && Number.isFinite(amount(displayPrice)) ?
        formatMoney(amount(displayPrice) + extraValue) : displayPrice;
      selectedCount.textContent = countText;
      if (countAtHeading) countAtHeading.textContent = countText;
      const extraEmpty = picked.slice(count).some(item => !item);
      const extrasUnavailable = !previewOnly && extraCount > 0 && !extrasCheckoutEnabled;
      add.disabled = addingToCart || !selectedVariant?.available || previewOnly || otherPackInBridge || left > 0 || extraEmpty || extrasUnavailable;
      add.textContent = previewOnly ? 'Aperçu uniquement · achat avec le module actuel' :
        otherPackInBridge ? 'Achat de ce pack en attente de l’application indépendante' :
        extrasUnavailable ? 'Couleurs supplémentaires : achat en préparation' :
        extraEmpty ? 'Choisissez la couleur supplémentaire' :
        left ? `Choisissez encore ${left} couleur${left > 1 ? 's' : ''} pour continuer` : `${labels.add}  |  ${totalPrice}  →`;
      const buttonText = left ? `Choisissez encore ${left} couleur${left > 1 ? 's' : ''} pour continuer` : `${labels.add}  |  ${displayPrice}  →`;
      const showPrice = button => {
        button.replaceChildren();
        if (left) { button.textContent = buttonText; return; }
        button.append(document.createTextNode(`${labels.add}  |  `));
        const old = config.packs?.[root.dataset.pack]?.old;
        const oldBase = old ? amount(plainPrice(old)) : amount(displayPrice);
        const oldPrice = extras.length && Number.isFinite(oldBase) ?
          formatMoney(oldBase + extras.reduce((sum, item) => sum + Number(item.priceCents || 0) / 100, 0)) : plainPrice(old);
        if (oldPrice) {
          const crossed = document.createElement('del');
          crossed.textContent = oldPrice;
          button.append(crossed, document.createTextNode('  '));
        }
        const current = document.createElement('strong');
        current.textContent = totalPrice;
        button.append(current, document.createTextNode('  →'));
      };
      showPrice(modalAdd);
      modalAdd.disabled = left > 0 || extraEmpty || extrasUnavailable;
      const modalMessage = modal.querySelector('.glaam-builder__modal-message');
      modalMessage.textContent = extrasUnavailable ? 'Couleur supplémentaire à −20 % : achat en attente de la mise à jour du panier.' : '';
      if (extraEmpty) modalAdd.textContent = 'Choisissez la couleur supplémentaire';
      if (extrasUnavailable && !extraEmpty) modalAdd.textContent = 'Couleurs supplémentaires : achat en préparation';
      if (previewOnly && !left) modalAdd.setAttribute('aria-label', 'Aperçu du bouton Ajouter au panier, achat désactivé');
      for (const button of [contentsAdd, stickyAdd]) {
        if (left) button.textContent = 'Choisissez vos couleurs';
        else if (extraEmpty) button.textContent = 'Choisissez la couleur supplémentaire';
        else if (extrasUnavailable) button.textContent = 'Couleurs supplémentaires : achat en préparation';
        else showPrice(button);
        button.disabled = extrasUnavailable;
      }
      baseRow.replaceChildren();
      picked.forEach((product, index) => {
        const tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'glaam-builder__summary-slot';
        tile.classList.toggle('is-current', index === slot);
        tile.dataset.summarySlot = String(index);
        tile.setAttribute('aria-label', product ? `Modifier ${product.name}` : `Choisir la couleur ${index + 1}`);
        if (product) {
          const img = document.createElement('img');
          img.src = product.image;
          img.alt = '';
          tile.append(img);
        } else tile.textContent = String(index + 1);
        const wrapper = document.createElement('div');
        wrapper.className = 'glaam-builder__summary-wrap';
        wrapper.append(tile);
        if (product) {
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'glaam-builder__summary-remove';
          remove.dataset.removeSummary = String(index);
          remove.textContent = '×';
          remove.setAttribute('aria-label', 'Supprimer ' + product.name);
          wrapper.append(remove);
        }
        baseRow.append(wrapper);
      });
      if (extrasCheckoutEnabled && !bridgeMode && !left && picked.length - count < 9) {
        const extra = document.createElement('button');
        extra.type = 'button';
        extra.className = 'glaam-builder__summary-slot is-extra';
        extra.dataset.addExtra = '';
        extra.innerHTML = '<span class="glaam-builder__extra-plus">+</span><small>'+extraBadge+'</small>';
        extra.setAttribute('aria-label', 'Ajouter une couleur supplémentaire'+(extraDiscount?' à moins '+extraDiscount+' pour cent':''));
        const wrap = document.createElement('div');
        wrap.className = 'glaam-builder__summary-wrap';
        wrap.append(extra);
        baseRow.append(wrap);
      }
      requestAnimationFrame(() => { refreshPageCarousel(); refreshSummaryCarousel(); });
      const contents = root.querySelector('.glaam-builder__contents-items');
      contents.replaceChildren();
      const entries = [
        { name: customization.nailsName || 'Glaam Nails au choix', quantity: count + picked.slice(count).filter(Boolean).length, image: includedImage('glaam nails au choix') || config.packImage },
        { name: customization.fileName || 'Lime à ongles', quantity: count + picked.slice(count).filter(Boolean).length, image: includedImage('limes') || config.fileImage },
        { name: customization.stickName || 'Bâtonnet de manucure', quantity: count + picked.slice(count).filter(Boolean).length, image: includedImage('bâtonnets') || config.stickImage },
        ...(config.lamp ? [{ name: customization.lampName || 'Lampe UV', quantity: 1, image: includedImage('lampe') || config.lampImage }] : []),
        ...(Boolean(config.oil) ? [{ name: customization.oilName || 'Huile de retrait', quantity: 1, image: config.oilImage }] : [])
      ];
      contents.classList.toggle('glaam-builder__contents-items--premium', Boolean(config.oil));
      for (const item of entries) {
        const card = document.createElement('div');
        card.className = 'glaam-builder__contents-item';
        const photo = document.createElement('img');
        photo.src = item.image || '';
        photo.alt = '';
        const title = document.createElement('span');
        title.textContent = item.name;
        const quantity = document.createElement('span');
        quantity.className = 'glaam-builder__contents-quantity';
        quantity.textContent = `×${item.quantity}`;
        const frame = document.createElement('div');
        frame.className = 'glaam-builder__contents-photo';
        frame.append(photo, quantity);
        card.append(frame, title);
        contents.append(card);
      }
      sticky.querySelector('.glaam-builder__sticky-title').textContent = config.productName || config.packs?.[root.dataset.pack]?.title || 'Votre pack';
      const packPhoto = config.packs?.[root.dataset.pack]?.image;
      if (packPhoto) sticky.querySelector('.glaam-builder__sticky-photo').src = packPhoto;
      applyCustomization();
    }

    function removeColor(index) {
      const remaining = picked.filter((product,position)=>product && position !== index);
      picked.splice(0,picked.length,...remaining);
      while(picked.length<count) picked.push(null);
      slot = picked.findIndex(item=>!item);
      if(slot<0) slot=picked.length;
      for(let i=0;i<count;i++) renderSlot(i);
      updateAdd();
      draw();
    }

    function renderSlot(index) {
      if (index >= count) return;
      const wrap = root.querySelectorAll('.glaam-builder__slot-wrap')[index];
      const tile = wrap.querySelector('.glaam-builder__slot');
      const remove = wrap.querySelector('.glaam-builder__remove');
      const product = picked[index];
      tile.replaceChildren();
      remove.hidden = !product;
      remove.setAttribute('aria-label', `Supprimer la couleur ${index + 1}${product ? ` : ${product.name}` : ''}`);
      if (product) {
        const img = document.createElement('img');
        img.src = product.image;
        img.alt = '';
        const name = document.createElement('span');
        name.textContent = product.name;
        tile.append(img, name);
        tile.setAttribute('aria-label', `Changer la couleur ${index + 1} : ${product.name}`);
      } else {
        const plus = document.createElement('span');
        plus.className = 'glaam-builder__plus';
        plus.textContent = '+';
        const name = document.createElement('span');
        name.textContent = slotLabel(index);
        tile.append(plus, name);
        tile.removeAttribute('aria-label');
      }
    }

    function changePack(kind) {
      const pack = config.packs?.[kind];
      if (!pack || kind === root.dataset.pack) return;
      root.dataset.pack = kind;
      count = pack.count;
      picked.length = count;
      if (bridgeMode) picked.fill(null);
      for (let i = 0; i < count; i++) {
        const product = picked[i];
        if (product === undefined) picked[i] = null;
      }
      displayPrice = shownPrice(pack, kind);
      config.lamp = pack.lamp ? config.defaultLamp : null;
      config.oil = kind === 'premium' ? config.premiumOil : null;
      const slots = root.querySelector('.glaam-builder__slots');
      slots.replaceChildren();
      picked.forEach((product, index) => {
        const wrap = document.createElement('div');
        wrap.className = 'glaam-builder__slot-wrap';
        const tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'glaam-builder__slot';
        tile.dataset.slot = `color-${index + 1}`;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'glaam-builder__remove';
        remove.hidden = true;
        remove.textContent = '×';
        wrap.append(tile, remove);
        slots.append(wrap);
        renderSlot(index);
      });
      rows?.querySelectorAll('a.bql-row').forEach(row => {
        const selected = row.getAttribute('href')?.includes(`/products/${pack.handle}`);
        row.classList.toggle('bql-row--selected', Boolean(selected));
        row.setAttribute('aria-current', selected ? 'true' : 'false');
      });
      refreshRowPrices();

      message.textContent = bridgeMode && kind !== originalPack ? 'Le choix reste sur cette fiche. L’achat de ce pack attend l’application indépendante.' : '';
      updateAdd();
    }

    function drawPackRows(formula) {
      if (!rows) return;
      if (formula === originalFormula && originalRows) {
        rows.innerHTML = originalRows;
        return;
      }
      rows.replaceChildren();
      const kinds = formula === 'with' ? ['essentiel', 'decouverte', 'premium'] : ['no3', 'no6', 'no9'];
      const subtitles = formula === 'with' ? ['Essentiel', 'Découverte', 'Premium'] : ['Essentiel', 'Standard', 'Premium'];
      kinds.forEach((kind, i) => {
        const pack = config.packs[kind];
        const row = document.createElement('a');
        row.className = 'bql-row';
        row.href = `/products/${pack.handle}#offre`;
        if (i === 1 || i === 2) {
          const badge = document.createElement('span');
          badge.className = `bql-row-badge bql-row-badge--${i === 1 ? 'popular' : 'best'}`;
          badge.textContent = i === 1 ? 'LE PLUS VENDU' : 'LA MEILLEURE OFFRE';
          row.append(badge);
        }
        const top = document.createElement('div');
        top.className = 'bql-row-top';
        const left = document.createElement('div');
        left.className = 'bql-row-left';
        const radio = document.createElement('span');
        radio.className = 'bql-radio';
        const titles = document.createElement('div');
        const title = document.createElement('div');
        title.className = 'bql-row-title';
        title.textContent = `${pack.count} COULEURS`;
        const subtitle = document.createElement('div');
        subtitle.className = 'bql-row-subtitle';
        subtitle.textContent = subtitles[i];
        titles.append(title, subtitle);
        left.append(radio, titles);
        const wrap = document.createElement('div');
        wrap.className = 'bql-row-price';
        const line = document.createElement('div');
        line.className = 'bql-row-price-line';
        if (pack.old) {
          const old = document.createElement('del');
          old.className = 'bql-row-old';
          old.textContent = plainPrice(pack.old);
          line.append(old);
        }
        const price = document.createElement('span');
        price.className = 'bql-row-new';
        price.textContent = shownPrice(pack, kind);
        line.append(price);
        wrap.append(line);
        top.append(left, wrap);
        const pills = document.createElement('div');
        pills.className = 'bql-row-pills';
        const pill = document.createElement('span');
        pill.className = 'bql-pill';
        pill.textContent = formula === 'with' ? '✓ Lampe UV incluse' : '✓ Sans lampe';
        pills.append(pill);
        row.append(top, pills);
        rows.append(row);
      });
    }

    function refreshRowPrices() {
      rows?.querySelectorAll('a.bql-row').forEach(row => {
        const key = Object.keys(config.packs).find(kind => row.href.includes(`/products/${config.packs[kind].handle}`));
        const price = row.querySelector('.bql-row-new');
        if (key && price) price.textContent = shownPrice(config.packs[key], key);
        const oldPrice = key && (plainPrice(config.packs[key].old) || originalOldPrices[key]);
        let oldNode = row.querySelector('.bql-row-old');
        if (oldPrice && price) {
          if (!oldNode) {
            oldNode = document.createElement('del');
            oldNode.className = 'bql-row-old';
          }
          oldNode.textContent = oldPrice;
          price.before(oldNode);
          price.parentElement.classList.add('glaam-row-prices');
        }
        if (key) {
          let per = row.querySelector('.bql-row-per-manucure');
          if (!per) {
            per = document.createElement('span');
            per.className = 'bql-row-per-manucure';
            const top = row.querySelector('.bql-row-top');
            if (top) top.after(per); else row.append(per);
          }
          const packAmount = amount(shownPrice(config.packs[key], key));
          if (Number.isFinite(packAmount)) {
            const value = document.createElement('strong');
            value.textContent = new Intl.NumberFormat('fr-FR', { style:'currency', currency:config.currency || 'EUR' }).format(packAmount / config.packs[key].count);
            per.replaceChildren(document.createTextNode('Soit '), value, document.createTextNode(' par manucure'));
            const subtitle = row.querySelector('.bql-row-subtitle');
            if (subtitle) per.style.fontSize = getComputedStyle(subtitle).fontSize;
          }
        }
        row.querySelector('.bql-row-description')?.remove();
        row.querySelector('.glaam-row-saving')?.remove();
        if (key) {
          const old = amount(oldPrice || '');
          const current = amount(shownPrice(config.packs[key], key));
          if (Number.isFinite(old) && Number.isFinite(current) && old > current) {
            const saving = document.createElement('span');
            saving.className = 'glaam-row-saving';
            saving.textContent = `Économiser ${Math.round((old - current) / old * 100)} %`;
            const badge = rows.querySelector('.bql-row-badge--popular') || rows.querySelector('.bql-row-badge');
            if (badge && row.classList.contains('bql-row--selected')) saving.style.backgroundColor = getComputedStyle(badge).backgroundColor;
            const rowStyle = getComputedStyle(row);
            row.style.setProperty('--glaam-row-inset', rowStyle.paddingLeft);
            row.style.setProperty('--glaam-row-bottom', rowStyle.paddingBottom);
            row.style.setProperty('--glaam-saving-radius', `${Math.max(0, parseFloat(rowStyle.borderBottomLeftRadius) - parseFloat(rowStyle.borderLeftWidth))}px`);
            row.append(saving);
          }
        }
      });
    }

    function showFormula(formula) {
      calibratePrice();
      if (currentFormula === originalFormula) originalRows = rows?.innerHTML;
      drawPackRows(formula);
      currentFormula = formula;
      formulaButtons.forEach(button => {
        const selected = (button.href.includes('pack-de-6-glaam-nails') ? 'without' : 'with') === formula;
        button.classList.toggle('bql-forfait-button--selected-pink', selected);
      });
      changePack(chosenByFormula[formula]);
      refreshRowPrices();
    }

    const priceData = root.querySelector('.glaam-builder__price-data');
    if (priceData) new MutationObserver(() => {
      const selected = config.packs[root.dataset.pack];
      if (!selected) return;
      displayPrice = shownPrice(selected, root.dataset.pack);
      refreshRowPrices();
      updateAdd();
    }).observe(priceData, { subtree: true, childList: true, characterData: true });

    // The picker can switch every pack locally. MOD can only sell the original
    // product on this page, so the cart stays disabled for other packs.
    if (config.packs) {
      formulaButtons.forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        showFormula(button.href.includes('pack-de-6-glaam-nails') ? 'without' : 'with');
      }));
      rows?.addEventListener('click', event => {
        const row = event.target.closest('a.bql-row');
        if (!row) return;
        const kind = Object.keys(config.packs).find(key => row.href.includes(`/products/${config.packs[key].handle}`));
        if (!kind) return;
        event.preventDefault();
        calibratePrice();
        chosenByFormula[kind.startsWith('no') ? 'without' : 'with'] = kind;
        changePack(kind);
      });
    }

    if (standalonePreview) {
      const note = document.createElement('p');
      note.className = 'glaam-builder__preview';
      note.textContent = 'Essai du sélecteur autonome sur le thème brouillon';
      root.prepend(note);
      document.body.classList.add('glaam-standalone-preview');
    }
    if (bridgeMode) {
      let attempts = 0;
      const connect = () => {
        const candidate = document.querySelector(`.collection-bundle-container[data-product-id="${root.dataset.productId}"]`);
        if (candidate?.querySelectorAll('.collection-selection-container[data-collection-slot]').length >= count &&
            candidate.querySelector('[data-collection-bundle-add-to-cart]')) {
          modContainer = candidate;
          candidate.classList.add('glaam-mod-bridge-hidden');
        } else if (++attempts < 100) {
          setTimeout(connect, 100);
        } else {
          message.textContent = 'Le module du pack est indisponible. Utilisez le sélecteur actuel.';
        }
      };
      connect();
    }

    function waitFor(predicate, timeout = 4000) {
      return new Promise((resolve, reject) => {
        const started = Date.now();
        const check = () => {
          if (predicate()) resolve();
          else if (Date.now() - started >= timeout) reject(new Error('Le produit n’a pas pu être sélectionné.'));
          else setTimeout(check, 50);
        };
        check();
      });
    }

    async function selectInMod(product, index) {
      if (!modContainer) throw new Error('Le module du pack n’est pas encore prêt.');
      const originalSlot = modContainer.querySelector(`.collection-selection-container[data-collection-slot="${index + 1}"] .collection-selection-item`);
      if (!originalSlot) throw new Error('Cet emplacement n’est pas disponible.');
      originalSlot.click();
      const popup = document.querySelector('#collection-product-modal');
      await waitFor(() => popup && getComputedStyle(popup).display !== 'none' && popup.querySelectorAll('.product-card').length > 0);
      const card = [...popup.querySelectorAll('.product-card')].find(item => item.dataset.productHandle === product.handle);
      const variants = card && JSON.parse(card.querySelector('.variant-data')?.textContent || '[]');
      if (!card || !variants.some(v => String(v.id) === String(product.id) && v.available)) {
        popup.querySelector('.close-modal')?.click();
        throw new Error('Cette couleur n’est plus disponible dans le pack.');
      }
      card.click();
      await waitFor(() => getComputedStyle(popup).display === 'none' &&
        modContainer.querySelector(`.collection-selection-container[data-collection-slot="${index + 1}"] .collection-product-title`)?.textContent.trim() === product.name);
    }

    const colors = new Map();
    const effects = new Set();
    const effectImages = new Map();
    const productTypes = new Set();
    const isColor = c => Boolean(c.hex) || c.name === 'Multicolore';
    const productEffects = product => [
      ...product.designs,
      ...product.colors.filter(c => !isColor(c)).map(c => c.name)
    ];
    for (const product of catalog) {
      for (const c of product.colors) {
        if (c.name && isColor(c)) colors.set(c.name, c.hex);
        else if (c.name && c.image && !effectImages.has(c.name)) effectImages.set(c.name, c.image);
      }
      for (const e of productEffects(product)) if (e) effects.add(e);
      if (product.type) productTypes.add(product.type);
    }

    const filterTabs = document.createElement('div');
    filterTabs.className = 'glaam-builder__filter-tabs';
    const filterPanels = document.createElement('div');
    filterPanels.className = 'glaam-builder__filter-panels';
    filters.append(filterTabs, filterPanels);
    function makeGroup(title, kind) {
      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'glaam-builder__filter-tab';
      tab.textContent = title;
      tab.dataset.tab = kind;
      tab.setAttribute('aria-expanded', 'false');
      const options = document.createElement('div');
      options.className = 'glaam-builder__filter-options';
      options.id = `glaam-filter-${kind}-${root.dataset.productId}`;
      options.dataset.panel = kind;
      options.hidden = true;
      tab.setAttribute('aria-controls', options.id);
      filterTabs.append(tab);
      filterPanels.append(options);
      return options;
    }

    function makeFilter(group, label, value, type, hex, picture) {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.kind = type;
      button.dataset.value = value;
      button.setAttribute('aria-pressed', 'false');
      if (type === 'color') {
        const dot = document.createElement('span');
        dot.className = 'glaam-builder__dot';
        dot.style.setProperty('--dot', /^#[0-9a-f]{6}$/i.test(hex || '') ? hex : 'conic-gradient(#e75275, #f6b944, #60b575, #6688df, #e75275)');
        button.append(dot);
      } else if (type === 'effect' && picture) {
        const swatch = document.createElement('img');
        swatch.className = 'glaam-builder__pattern';
        swatch.src = picture;
        swatch.alt = '';
        swatch.loading = 'lazy';
        button.append(swatch);
      }
      button.append(document.createTextNode(label));
      group.append(button);
    }
    const definitions=customization.filters||[{id:'type',label:'Type de produit',source:'type'},{id:'color',label:'Couleur',source:'color'},{id:'effect',label:'Effet',source:'effect'}];
    const activeFilters={};
    const valuesFor=(p,f)=>{
      if(f.source==='color')return p.colors.filter(isColor).map(c=>c.name);
      if(f.source==='effect')return productEffects(p);
      if(f.source==='type')return p.type?[p.type]:[];
      if(f.source==='tag'){
        const prefix=String(f.tagPrefix||'').trim();
        const tags=p.tags||[];
        if(!prefix)return tags;
        return tags.filter(tag=>String(tag).toLocaleLowerCase('fr').startsWith(prefix.toLocaleLowerCase('fr'))).map(tag=>String(tag).slice(prefix.length).trim()).filter(Boolean);
      }
      if(f.source==='collection')return p.collections||[];
      if(f.source==='price')return [new Intl.NumberFormat('fr-FR',{style:'currency',currency:config.currency||'EUR'}).format(p.priceCents/100)];
      const v=p.customFilters?.[f.id];return (Array.isArray(v)?v:[v]).filter(v=>v!=null).map(v=>typeof v==='object'?(v.label||v.name||JSON.stringify(v)):String(v));
    };
    function refreshFilters(){
      const expanded=new Set([...filterTabs.querySelectorAll('[aria-expanded="true"]')].map(tab=>tab.dataset.tab));
      colors.clear();effectImages.clear();
      for(const product of catalog)for(const c of product.colors){if(c.name&&isColor(c))colors.set(c.name,c.hex);else if(c.name&&c.image&&!effectImages.has(c.name))effectImages.set(c.name,c.image);}
      filterTabs.replaceChildren();filterPanels.replaceChildren();
      for(const f of definitions){const group=makeGroup(f.label,f.id);const values=new Set(catalog.flatMap(p=>valuesFor(p,f)));for(const value of [...values].sort((a,b)=>a.localeCompare(b,'fr',{numeric:true})))makeFilter(group,value,value,f.id,f.source==='color'?colors.get(value):null,f.source==='effect'?effectImages.get(value):null);if(expanded.has(f.id)){group.hidden=false;filterTabs.querySelector(`[data-tab="${f.id}"]`).setAttribute('aria-expanded','true');}}
    }
    refreshFilters();
    let catalogLoader=null,catalogFailed=false;
    function loadRemainingCatalog(){
      if(!catalogLoader)return;
      const note=modal.querySelector('.glaam-builder__modal-message');
      if(catalogFailed){note.textContent='';catalogFailed=false;}
      modal.setAttribute('aria-busy','true');
      catalogLoader.loadAll().catch(()=>{catalogFailed=true;note.textContent='Certaines couleurs n’ont pas pu être chargées. Fermez puis rouvrez la sélection pour réessayer.';}).finally(()=>modal.removeAttribute('aria-busy'));
    }
    function draw() {
      const term=customization.showSearch===false?'':search.value.trim().toLocaleLowerCase('fr');
      const favorites=readFavorites();
      const containsTerm=p=>(!favoritesOnly||favorites.has(p.handle))&&(!term||p.name.toLocaleLowerCase('fr').includes(term));
      const matches=(p,except)=>definitions.every(f=>f.id===except||!activeFilters[f.id]||valuesFor(p,f).includes(activeFilters[f.id]));
      filters.querySelectorAll('button[data-kind]').forEach(button=>{const f=definitions.find(f=>f.id===button.dataset.kind);button.hidden=!catalog.some(p=>containsTerm(p)&&matches(p,f.id)&&valuesFor(p,f).includes(button.dataset.value))&&activeFilters[f.id]!==button.dataset.value;});
      const matching=catalog.filter(p=>containsTerm(p)&&matches(p));
      if (sortSelect.value === 'az') matching.sort((a,b)=>a.name.localeCompare(b.name,'fr',{sensitivity:'base',numeric:true}));
      else if (sortSelect.value === 'newest') matching.sort((a,b)=>Number(b.createdAt)-Number(a.createdAt));
      else if (sortSelect.value === 'best-selling' && bestSellerRanks) matching.sort((a,b)=>(bestSellerRanks.get(a.handle) ?? Infinity)-(bestSellerRanks.get(b.handle) ?? Infinity));
      if (sortSelect.value === 'recommended' && bestSellerRanks) {
        const popular = [...matching].sort((a,b)=>(bestSellerRanks.get(a.handle) ?? Infinity)-(bestSellerRanks.get(b.handle) ?? Infinity));
        const recent = [...matching].filter(p=>Number(p.createdAt)>Date.now()/1000-60*86400).sort((a,b)=>Number(b.createdAt)-Number(a.createdAt));
        const ordered = [];
        const seen = new Set();
        while (popular.length || recent.length) {
          for (let i=0;i<3 && popular.length;i++) {
            while (popular.length && seen.has(popular[0].id)) popular.shift();
            const product = popular.shift();
            if(product){ordered.push(product);seen.add(product.id);}
          }
          while(recent.length && seen.has(recent[0].id)) recent.shift();
          const novelty=recent.shift();
          if(novelty){ordered.push(novelty);seen.add(novelty.id);}
        }
        matching.splice(0,matching.length,...ordered);
      }
      grid.replaceChildren();
      for (const product of matching) {
        const card = document.createElement('div');
        card.className = 'glaam-builder__product-card';
        const quantity = picked.filter(item => item && String(item.id) === String(product.id)).length;
        card.classList.toggle('is-picked', quantity > 0);
        const media = document.createElement('div');
        media.className = 'glaam-builder__product-media';
        if (product.badges?.length) {
          const badges = document.createElement('div');
          badges.className = 'glaam-builder__product-badges';
          for (const item of product.badges) {
            const badge = document.createElement('span');
            badge.className = 'glaam-builder__product-badge';
            badge.textContent = item.text;
            if (item.bg) badge.style.backgroundColor = item.bg;
            if (item.fg) badge.style.color = item.fg;
            if (item.border) badge.style.borderColor = item.border;
            badges.append(badge);
          }
          media.append(badges);
        }
        if (quantity) {
          const checked = document.createElement('span');
          checked.className = 'glaam-builder__picked-mark';
          checked.textContent = '✓';
          checked.setAttribute('aria-label', 'Sélectionné');
          media.append(checked);
        }
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'glaam-builder__product';
        button.dataset.id = product.id;
        button.setAttribute('aria-label', `Ajouter ${product.name}`);
        const img = document.createElement('img');
        img.src = product.image;
        img.alt = product.name;
        img.loading = 'lazy';
        button.append(img);
        media.append(button);
        const view = document.createElement('button');
        view.type = 'button';
        view.className = 'glaam-builder__view';
        view.dataset.viewId = product.id;
        view.setAttribute('aria-label', `Voir les photos de ${product.name}`);
        view.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6"></circle><path d="m15 15 5 5"></path></svg>';
        media.append(view);
        const name = document.createElement('strong');
        name.className = 'glaam-builder__product-name';
        name.textContent = product.name;
        card.append(media, name);
        if (quantity) {
          const controls = document.createElement('div');
          controls.className = 'glaam-builder__card-quantity';
          const minus = document.createElement('button');
          minus.type = 'button';
          minus.dataset.removeId = product.id;
          minus.setAttribute('aria-label', `Retirer un exemplaire de ${product.name}`);
          minus.textContent = '−';
          const total = document.createElement('output');
          total.textContent = quantity;
          const plus = document.createElement('button');
          plus.type = 'button';
          plus.dataset.addId = product.id;
          plus.setAttribute('aria-label', `Ajouter un exemplaire de ${product.name}`);
          plus.textContent = '+';
          controls.append(minus, total, plus);
          card.append(controls);
        } else {
          const action = document.createElement('button');
          action.type = 'button';
          action.className = 'glaam-builder__card-action';
          action.dataset.id = product.id;
          action.textContent = '+ Ajouter';
          card.append(action);
        }
        grid.append(card);
      }
      if (!matching.length) {
        const empty = document.createElement('p');
        empty.textContent = favoritesOnly ? 'Aucun de vos favoris n’est en stock dans ce sélecteur.' : 'Aucune couleur trouvée.';
        grid.append(empty);
      }
    }

    function showGalleryPhoto() {
      const images = galleryProduct.images?.length ? galleryProduct.images : [galleryProduct.image];
      const photo = gallery.querySelector('.glaam-builder__gallery-photo');
      photo.src = images[galleryIndex];
      photo.alt = `${galleryProduct.name} · photo ${galleryIndex + 1} sur ${images.length}`;
      gallery.querySelector('.glaam-builder__gallery-prev').disabled = images.length < 2;
      gallery.querySelector('.glaam-builder__gallery-next').disabled = images.length < 2;
      const position = gallery.querySelector('.glaam-builder__gallery-position');
      position.setAttribute('aria-label', `Photo ${galleryIndex + 1} sur ${images.length}`);
      position.querySelectorAll('button').forEach((dot, index) => dot.setAttribute('aria-current', String(index === galleryIndex)));
    }
    function openGallery(product, focus) {
      galleryProduct = product;
      galleryIndex = 0;
      galleryFocus = focus;
      gallery.querySelector('.glaam-builder__gallery-title').textContent = product.name;
      const dialogRect = modal.querySelector('.glaam-builder__dialog').getBoundingClientRect();
      gallery.style.setProperty('--glaam-gallery-top', `${Math.max(12, dialogRect.top)}px`);
      gallery.style.setProperty('--glaam-gallery-height', `${dialogRect.height}px`);
      const position = gallery.querySelector('.glaam-builder__gallery-position');
      position.replaceChildren();
      (product.images?.length ? product.images : [product.image]).forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.dataset.photo = String(index);
        dot.setAttribute('aria-label', `Photo ${index + 1}`);
        position.append(dot);
      });
      modal.inert = true;
      gallery.hidden = false;
      showGalleryPhoto();
      gallery.querySelector('[data-gallery-close]:not(.glaam-builder__gallery-backdrop)').focus();
    }
    function closeGallery() {
      gallery.hidden = true;
      modal.inert = false;
      galleryFocus?.focus();
      galleryProduct = null;
    }

    function open(index) {
      slot = index;
      previousFocus = document.activeElement;
      modal.querySelector('.glaam-builder__heading').textContent = popupTitle;
      modal.hidden = false;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      draw();
      loadRemainingCatalog();
      modal.querySelector('.glaam-builder__search-toggle').focus();
    }
    function close() {
      if (!gallery.hidden) closeGallery();
      modal.hidden = true;
      document.body.style.overflow = previousOverflow;
      previousFocus?.focus();
    }
    const openNextColor = () => open(Math.max(0, picked.slice(0, count).findIndex(item => !item)));
    contentsAdd.addEventListener('click', () => {
      if (picked.slice(0, count).some(item => !item)) openNextColor();
      else if (picked.slice(count).some(item => !item)) open(picked.findIndex((item, index) => index >= count && !item));
      else add.click();
    });
    stickyAdd.addEventListener('click', () => {
      if (picked.slice(0, count).some(item => !item)) openNextColor();
      else if (picked.slice(count).some(item => !item)) open(picked.findIndex((item, index) => index >= count && !item));
      else add.click();
    });
    modalAdd.addEventListener('click', () => {
      if (previewOnly) { close(); message.textContent = 'Sélection enregistrée pour la maquette · achat désactivé.'; return; }
      if (picked.length > count && !extrasCheckoutEnabled) {
        modal.querySelector('.glaam-builder__modal-message').textContent = 'La réduction de 20 % attend la mise à jour de l’application panier.';
        return;
      }
      if (previewOnly) {
        message.textContent = 'Maquette : ajout au panier désactivé pour valider le design.';
        return;
      }
      add.click();
    });
    summary.addEventListener('click', event => {
      const remove = event.target.closest('[data-remove-summary]');
      if (remove) {
        const index = Number(remove.dataset.removeSummary);
        removeColor(index);
        return;
      }
      const extra = event.target.closest('[data-add-extra]');
      if (extra) {
        if (!extrasCheckoutEnabled || bridgeMode) return;
        if (picked.length - count >= 9) return;
        const emptyExtra = picked.findIndex((item, index) => index >= count && !item);
        if (emptyExtra >= 0) {
          slot = emptyExtra;
        } else {
        picked.push(null);
        slot = picked.length - 1;
        }
        modal.querySelector('.glaam-builder__heading').textContent = popupTitle;
        modal.querySelector('.glaam-builder__modal-message').textContent = '';
        updateAdd();
        draw();
        grid.scrollTop = 0;
        return;
      }
      const target = event.target.closest('[data-summary-slot]');
      if (!target) return;
      slot = Number(target.dataset.summarySlot);
      modal.querySelector('.glaam-builder__heading').textContent = popupTitle;
      updateAdd();
      grid.scrollTop = 0;
    });
    sticky.hidden = false;
    sticky.classList.add('glaam-variant-sticky');
    document.body.append(sticky);
    document.body.classList.add('glaam-has-variant-sticky');
    const syncStickyVisibility = () => {
      const pageButtonVisible = [contentsAdd,add].some(button => {
        if(!button.getClientRects().length) return false;
        const rect=button.getBoundingClientRect();
        return rect.bottom>0 && rect.top<window.innerHeight && rect.right>0 && rect.left<window.innerWidth;
      });
      sticky.hidden=customization.stickyEnabled===false || pageButtonVisible || document.querySelector('cart-drawer.active,cart-drawer[open]')!==null;
    };
    const stickyObserver=new IntersectionObserver(syncStickyVisibility,{threshold:0});
    stickyObserver.observe(contentsAdd);
    stickyObserver.observe(add);
    const cartDrawer=document.querySelector('cart-drawer');
    if(cartDrawer)new MutationObserver(syncStickyVisibility).observe(cartDrawer,{attributes:true,attributeFilter:['class','open']});
    window.addEventListener('resize',syncStickyVisibility,{passive:true});
    syncStickyVisibility();
    pageSlots.addEventListener('click', event => {
      if (event.target.closest('[data-inline-extra]')) { handlePageExtra(event); return; }
      const remove = event.target.closest('.glaam-builder__remove');
      if (remove) {
        const index = [...remove.closest('.glaam-builder__slots').children].indexOf(remove.parentElement);
        if (index < 0) return;
        removeColor(index);
        return;
      }
      const button = event.target.closest('.glaam-builder__slot');
      if (button) open([...button.closest('.glaam-builder__slots').children].indexOf(button.parentElement));
    });
    function handlePageExtra(event) {
      const remove = event.target.closest('[data-remove-extra]');
      if (remove) {
        removeColor(Number(remove.dataset.removeExtra));
        return;
      }
      const selected = event.target.closest('[data-extra-slot]');
      if (selected) { open(Number(selected.dataset.extraSlot)); return; }
      if (extrasCheckoutEnabled && event.target.closest('[data-page-add-extra]') && picked.length - count < 9) {
        picked.push(null);
        updateAdd();
        open(picked.length - 1);
      }
        }
    modal.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', close));
    modal.addEventListener('keydown', event => {
      if (event.key === 'Escape') close();
    });
    gallery.querySelectorAll('[data-gallery-close]').forEach(button => button.addEventListener('click', closeGallery));
    gallery.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeGallery();
      if (event.key === 'ArrowRight') gallery.querySelector('.glaam-builder__gallery-next').click();
      if (event.key === 'ArrowLeft') gallery.querySelector('.glaam-builder__gallery-prev').click();
    });
    gallery.querySelector('.glaam-builder__gallery-prev').addEventListener('click', () => {
      const size = galleryProduct.images?.length || 1;
      galleryIndex = (galleryIndex + size - 1) % size;
      showGalleryPhoto();
    });
    gallery.querySelector('.glaam-builder__gallery-next').addEventListener('click', () => {
      const size = galleryProduct.images?.length || 1;
      galleryIndex = (galleryIndex + 1) % size;
      showGalleryPhoto();
    });
    gallery.querySelector('.glaam-builder__gallery-position').addEventListener('click', event => {
      const dot = event.target.closest('button[data-photo]');
      if (!dot || !galleryProduct) return;
      galleryIndex = Number(dot.dataset.photo);
      showGalleryPhoto();
    });
    const swipePhoto = gallery.querySelector('.glaam-builder__gallery-photo');
    let swipeStart = null;
    const finishSwipe = (x, y) => {
      if (!swipeStart || !galleryProduct) return;
      const dx = x - swipeStart.x;
      const dy = y - swipeStart.y;
      swipeStart = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      gallery.querySelector(dx < 0 ? '.glaam-builder__gallery-next' : '.glaam-builder__gallery-prev').click();
    };
    swipePhoto.addEventListener('touchstart', event => {
      if (event.touches.length === 1) swipeStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }, { passive: true });
    swipePhoto.addEventListener('touchend', event => {
      if (event.changedTouches.length === 1) finishSwipe(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
    }, { passive: true });
    swipePhoto.addEventListener('touchcancel', () => { swipeStart = null; });
    swipePhoto.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'touch' && event.isPrimary) swipeStart = { x: event.clientX, y: event.clientY };
    });
    swipePhoto.addEventListener('pointerup', event => {
      if (event.pointerType !== 'touch') finishSwipe(event.clientX, event.clientY);
    });
    swipePhoto.addEventListener('pointercancel', () => { swipeStart = null; });
    swipePhoto.addEventListener('dragstart', event => event.preventDefault());
    gallery.addEventListener('click', event => {
      if (!event.target.closest('.glaam-builder__gallery-select')) return;
      event.preventDefault();
      event.stopPropagation();
      const id = galleryProduct?.id;
      if (!id) return;
      closeGallery();
      grid.querySelector(`.glaam-builder__product[data-id="${id}"]`)?.click();
    }, true);
    modal.querySelector('.glaam-builder__search-toggle').addEventListener('click', event => {
      search.hidden = !search.hidden;
      event.currentTarget.setAttribute('aria-expanded', String(!search.hidden));
      if (!search.hidden) {
        filters.hidden = true;
        modal.querySelector('.glaam-builder__filter-toggle').setAttribute('aria-expanded', 'false');
        search.focus();
      }
    });
    modal.querySelector('.glaam-builder__filter-toggle').addEventListener('click', event => {
      filters.hidden = !filters.hidden;
      event.currentTarget.setAttribute('aria-expanded', String(!filters.hidden));
      if (!filters.hidden) {
        search.hidden = true;
        search.value = '';
        modal.querySelector('.glaam-builder__search-toggle').setAttribute('aria-expanded', 'false');
        draw();
      }
      if (!filters.hidden && !filters.querySelector('.glaam-builder__filter-tab[aria-expanded="true"]'))
        filters.querySelector('[data-tab]')?.click();
    });
    modal.querySelector('.glaam-builder__favorites-toggle').addEventListener('click', event => {
      favoritesOnly = !favoritesOnly;
      event.currentTarget.setAttribute('aria-pressed', String(favoritesOnly));
      event.currentTarget.setAttribute('aria-label', favoritesOnly ? 'Afficher toutes les couleurs' : 'Afficher mes favoris');
      draw();
      grid.scrollTop = 0;
    });
    search.addEventListener('input', draw);
    filters.addEventListener('click', event => {
      const tab = event.target.closest('button[data-tab]');
      if (tab) {
        const opening = tab.getAttribute('aria-expanded') !== 'true';
        filters.querySelectorAll('button[data-tab]').forEach(item => item.setAttribute('aria-expanded', String(item === tab && opening)));
        filters.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== tab.dataset.tab || !opening; });
        return;
      }
      const button = event.target.closest('button[data-kind]');
      if (!button) return;
      const key = button.dataset.kind;
      activeFilters[key]=activeFilters[key]===button.dataset.value?'':button.dataset.value;
      filters.querySelectorAll('button[data-kind]').forEach(item=>item.setAttribute('aria-pressed',String(activeFilters[item.dataset.kind]===item.dataset.value)));
      draw();
    });
    let selecting = false;
    grid.addEventListener('click', async event => {
      const remove = event.target.closest('button[data-remove-id]');
      if (remove) {
        if (selecting) return;
        const index = picked.findLastIndex(item => item && String(item.id) === remove.dataset.removeId);
        if (index < 0) return;
        removeColor(index);
        return;
      }
      const addOne = event.target.closest('button[data-add-id]');
      if (addOne) {
        grid.querySelector(`.glaam-builder__product[data-id="${addOne.dataset.addId}"]`)?.click();
        return;
      }
      const view = event.target.closest('button[data-view-id]');
      if (view) {
        const product = catalog.find(p => String(p.id) === view.dataset.viewId);
        if (product) openGallery(product, view);
        return;
      }
      const button = event.target.closest('button[data-id]');
      if (!button || selecting) return;
      const product = catalog.find(p => String(p.id) === button.dataset.id);
      if (!product) return;
      if (extrasCheckoutEnabled && !bridgeMode && picked.every(Boolean) && slot >= picked.length) {
        if (picked.length - count >= 9) return;
        picked.push(null);
        slot = picked.length - 1;
      }
      selecting = true;
      button.disabled = true;
      if (bridgeMode && root.dataset.pack === originalPack) {
        try {
          await selectInMod(product, slot);
        } catch (error) {
          message.textContent = error.message;
          if (modContainer) modContainer.classList.remove('glaam-mod-bridge-hidden');
          add.disabled = true;
          close();
          return;
        } finally {
          button.disabled = false;
          selecting = false;
        }
      } else {
        selecting = false;
        button.disabled = false;
      }
      const selectedScroll = grid.scrollTop;
      picked[slot] = product;
      renderSlot(slot);
      updateAdd();
      const next = picked.findIndex((item, index) => index > slot && !item);
      const firstEmpty = next < 0 ? picked.findIndex(item => !item) : next;
      if (firstEmpty < 0) {
        slot = picked.length;
        modal.querySelector('.glaam-builder__heading').textContent = popupTitle;
        draw();
        grid.scrollTop = selectedScroll;
        return;
      }
      slot = firstEmpty;
      modal.querySelector('.glaam-builder__heading').textContent = popupTitle;
      draw();
      grid.scrollTop = selectedScroll;

    });

    add.addEventListener('click', async () => {
      if (addingToCart || !selectedVariant?.available || previewOnly || picked.length < count || picked.some(item => !item) || picked.length > count + 9 || (picked.length > count && !extrasCheckoutEnabled)) return;
      const expectedPrice = Number(selectedVariant.price) + picked.slice(count).reduce((sum, item) => sum + Math.round(Number(item.priceCents || 0) * extraFactor), 0);
      addingToCart = true;
      const buttons = [add, modalAdd, contentsAdd, stickyAdd];
      buttons.forEach(button => { button.disabled = true; });
      const group = 'glaam-' + crypto.randomUUID();
      const packOldPrice = Math.max(Number(selectedVariant.compare_at_price || 0), Number(selectedVariant.price || 0));
      const knownMaquettePacks = {
        55141050679635: {key:'essentiel',count:2,price:3490,lamp:49132251513171,oil:0},
        55141050712403: {key:'decouverte',count:4,price:4790,lamp:49132251513171,oil:0},
        55141050745171: {key:'premium',count:7,price:6490,lamp:49132251513171,oil:50494034575699},
        55141050777939: {key:'no3',count:3,price:3490,lamp:0,oil:0},
        55141050810707: {key:'no6',count:6,price:5990,lamp:0,oil:0},
        55141050843475: {key:'no9',count:9,price:6990,lamp:0,oil:0}
      };
      const knownPack = knownMaquettePacks[selectedVariant.id];
      const useKnownMaquettePack = root.dataset.productId === '10897914986835' &&
        config.currency === 'EUR' && knownPack &&
        count === knownPack.count && Number(selectedVariant.price) === knownPack.price &&
        Number(config.lamp || 0) === knownPack.lamp && Number(config.oil || 0) === knownPack.oil &&
        (picked.length === count || extraDiscount === 20);
      const properties = slot => ({_glaam_group:group,_glaam_pack:useKnownMaquettePack?knownPack.key:root.dataset.pack,_glaam_slot:slot,_glaam_pack_old:String(packOldPrice),...(!useKnownMaquettePack&&customization.variantRules?.['gid://shopify/ProductVariant/'+selectedVariant.id]?{_glaam_product:'gid://shopify/Product/'+root.dataset.productId,_glaam_variant:'gid://shopify/ProductVariant/'+selectedVariant.id}:{})});
      const items = picked.map((item,index)=>({id:item.id,quantity:1,properties:properties('color-'+(index+1))}));
      if(config.lamp) items.unshift({id:config.lamp,quantity:1,properties:properties('lamp')});
      if(config.oil) items.push({id:config.oil,quantity:1,properties:properties('oil')});
      try {
        const route = window.Shopify?.routes?.root || '/';
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer?.getSectionsToRender?.().map(section => section.id) || [];
        const response = await fetch(route + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items,
            ...(sections.length ? { sections, sections_url: window.location.pathname } : {})
          })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Ajout au panier impossible.');
        const rendered = new DOMParser().parseFromString(result.sections?.['cart-drawer'] || '', 'text/html');
        const bundle = rendered.querySelector('[data-glaam-native-group="'+group+'"]');
        if (!bundle || Number(bundle.dataset.glaamPrice) !== expectedPrice) {
          const cart = await (await fetch(route+'cart.js')).json();
          const updates = {};
          cart.items.filter(item=>item.properties?._glaam_group===group).forEach(item=>{updates[item.key]=0;});
          if(Object.keys(updates).length) await fetch(route+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
          throw new Error("Le regroupement Shopify du pack n’est pas encore actif. Aucun pack n’a été ajouté. Le prix et les stocks doivent être validés avant l’achat.");
        }
        close();
        if (drawer?.renderContents && result.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(result);
        } else {
          window.location.assign(route + 'cart');
        }
      } catch (error) {
        message.textContent = error.message;
        modal.querySelector('.glaam-builder__modal-message').textContent = error.message;
      } finally {
        addingToCart = false;
        updateAdd();
      }
    });

    function updateVariantMedia(variant) {
      const mediaId = variant.featured_media?.id;
      const productSection = root.closest('[id^="MainProduct-"]') || root.closest('.shopify-section');
      if (!mediaId || !productSection) return;
      productSection.querySelectorAll('media-gallery').forEach(gallery => {
        const target = [...gallery.querySelectorAll('[data-media-id]')].find(item =>
          item.dataset.mediaId.endsWith('-' + mediaId)
        );
        if (!target) return;
        if (typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(target.dataset.mediaId, true);
        } else if (!customElements.get('media-gallery')) {
          customElements.whenDefined('media-gallery').then(() => {
            if (selectedVariant?.id === variant.id) updateVariantMedia(variant);
          });
        }
      });
    }
    root.updateVariant = variant => {
      selectedVariant = variant;
      updateVariantMedia(variant);
      const legacyKeys={'Avec lampe':{Essentiel:'essentiel','Découverte':'decouverte',Premium:'premium'},'Sans lampe':{Essentiel:'no3','Découverte':'no6',Premium:'no9'}};
      const rule=customization.variantRules?.['gid://shopify/ProductVariant/'+variant.id];
      const legacy=legacyKeys[variant.option1]?.[variant.option2];
      const kind=rule?'variant-'+variant.id:legacy;
      if(!kind)return;
      const format=cents=>new Intl.NumberFormat('fr-FR',{style:'currency',currency:config.currency||'EUR'}).format(cents/100);
      const existing=config.packs[kind]||config.packs[legacy]||{};
      config.packs[kind]={...existing,count:rule?.colorCount||existing.count||1,lamp:rule?rule.lamp:variant.option1==='Avec lampe',price:format(variant.price),old:variant.compare_at_price>variant.price?format(variant.compare_at_price):null,title:rule?.label||variant.option2||variant.title,image:variant.featured_image?.src||existing.image||config.productImage};
      if(root.dataset.pack===kind)root.dataset.pack='refresh';
      changePack(kind);
      displayPrice=format(variant.price);
      config.lamp=config.packs[kind].lamp?config.defaultLamp:null;
      config.oil=(rule?rule.oil:kind==='premium')?config.premiumOil:null;
      const contents=root.querySelector('.glaam-builder__contents-items');
      if(rule)contents.style.setProperty('grid-template-columns','repeat('+rule.contentsColumns+',minmax(0,1fr))','important');
      updateAdd();
    };
    const preview = root.closest('#glaam-variant-demo');
    const variants = JSON.parse(preview.querySelector('[data-variants]').textContent);
    const initial = variants.find(v => String(v.id) === preview.dataset.selectedVariant) || variants.find(v => String(v.id) === new URL(location.href).searchParams.get('variant')) || variants.find(v => customization.variantRules?.['gid://shopify/ProductVariant/'+v.id]?.default && customization.variantRules['gid://shopify/ProductVariant/'+v.id].enabled!==false) || variants[0];
    root.updateVariant(initial);
    const syncInitialVariantMedia = () => {
      const requested = new URL(location.href).searchParams.get('variant');
      updateVariantMedia(variants.find(variant => String(variant.id) === requested) || selectedVariant);
    };
    if (document.readyState === 'complete') syncInitialVariantMedia();
    else window.addEventListener('load', syncInitialVariantMedia, { once: true });
    updateAdd();
    const visibility=customization.sectionVisibility||{};
    const sectionContainers=preview.querySelectorAll(':scope > .bql-container');
    const hideSection=(id,elements)=>{if(visibility[id]===false)for(const el of elements)if(el)el.style.setProperty('display','none','important');};
    hideSection('formulas',[sectionContainers[0]]);
    hideSection('packs',[sectionContainers[1],preview.querySelector('.gvd-hint')]);
    hideSection('colors',[colorsHeading,pageSlots.closest('.glaam-colors-carousel'),selectedCount]);
    const contentsSection=root.querySelector('.glaam-builder__contents');
    if(visibility.contents===false){contentsSection.after(contentsAdd);hideSection('contents',[contentsSection]);}
    hideSection('atc',[contentsAdd,add]);
    const order=customization.sectionOrder;
    if(order&&order.join(',')!=='formulas,packs,colors,contents,atc'){
      preview.style.display='flex';preview.style.flexDirection='column';root.style.display='contents';
      const containers=preview.querySelectorAll(':scope > .bql-container');
      if(containers[0])containers[0].style.order=order.indexOf('formulas');
      if(containers[1])containers[1].style.order=order.indexOf('packs');
      preview.querySelector('.gvd-hint').style.order=order.indexOf('packs');
      for(const el of [colorsHeading,pageSlots.closest('.glaam-colors-carousel'),selectedCount])el.style.order=order.indexOf('colors');
      const contents=root.querySelector('.glaam-builder__contents');contents.style.order=order.indexOf('contents');
      contents.after(contentsAdd);contentsAdd.style.order=order.indexOf('atc');
    }
    syncStickyVisibility();
    const pagination=JSON.parse(root.querySelector('.glaam-builder__catalog-pagination')?.textContent||'{"next":null}');
    if(pagination.next&&window.GlaamCatalogLoader){
      const baseUrl=new URL(location.href);if(new URL(location.href).searchParams.has('preview_theme_id')&&config.themeId)baseUrl.searchParams.set('preview_theme_id',String(config.themeId));
      catalogLoader=window.GlaamCatalogLoader.create({catalog,next:pagination.next,baseUrl:baseUrl.href,onPage:()=>{refreshFilters();if(!modal.hidden&&gallery.hidden){const scroll=grid.scrollTop;draw();grid.scrollTop=scroll;}}});
      loadRemainingCatalog();
    }
    root.dataset.initialized='true';
    root.dispatchEvent(new CustomEvent('glaam:ready',{bubbles:true}));
    bestSellerLoading=loadBestSellerRanks();
    bestSellerLoading.then(()=>{if(!modal.hidden && sortSelect.value==='recommended') draw();}).catch(()=>{bestSellerLoading=null;});
  }
})();


